import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    cursor: pointer;
    > p {
      white-space: nowrap;
      color: black;
      margin-left: ${theme.spacing.inline.small};
    }
  `}
`
